import React, {Component} from 'react';
import { translate } from 'react-i18next';
import DatabaseService from 'services/DatabaseService.js';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {initNavbarState} from 'actions/navbar.js';
import {fetchLeaderboard} from 'actions/leaderboards.js';
import {getLeaderboard} from 'reducers/leaderboards.js';
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import Utils from 'utils/Utils.js';
import Challenge from 'modules/challenges/Challenge.js';

import _ from 'underscore';

import SelectTeam from './SelectTeam.js';

class SelectTeamContainer extends Component {
    constructor(props) {
        super(props);
        this.start = 0;
        this.limit = 10;
        this.keywords = '';
        this.userProfiles = [];
        this.state = {busy:false, 
                      userProfiles:this.userProfiles, 
                      keywords:'',
                      showChallenge:false};
        this.onSelectUser = this.onSelectUser.bind(this);
        this.onDeselectUser = this.onDeselectUser.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.onClickContinue = this.onClickContinue.bind(this);
        this.onCloseChallenge = this.onCloseChallenge.bind(this);
        this.loadDataDebounced = _.debounce(this.loadData, 300);
        this.onScroll = this.onScroll.bind(this);
        this.setScrollContainer = this.setScrollContainer.bind(this);
        this.apiCallId = 0;
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:true, rewardsEnable:false, title:this.props.t("Select Your Team")}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    onScroll(event) {
        this.loadPageIfEndVisible();
    }

    setScrollContainer(el) {
        this.scrollContainer = el;
    }

    loadPageIfEndVisible() {
        if(this.scrollContainer) {
            var scrollTop =    this.scrollContainer.scrollTop;
            var scrollHeight = this.scrollContainer.scrollHeight;
            var clientHeight = this.scrollContainer.clientHeight;
            var lastPageInView = (scrollTop >= scrollHeight - 1.5*clientHeight);
            if(lastPageInView) {
                this.nextPage();
            }
        }
    }

    loadData() {
        this.start = 0;
        this.keywords = this.state.keywords;
        this.endReached = false;
        this.userProfiles = [];
        if(this.scrollContainer) {
            this.scrollContainer.scrollTop = 0;
        }
        this.busy = false;
        this.nextPage();
    }

    nextPage() {
        if(!this.busy && !this.endReached) {
            this.busy = true;
            this.setState({busy:this.busy});
            this.apiCallId++;
            var apiCallId = this.apiCallId;
            this.props.loadData({start:this.start, limit:this.limit, keywords:this.keywords})
                .then(([leaderboardResult, result])=>{
                    if(apiCallId==this.apiCallId) {
                        console.log('accept ' + apiCallId);
                        var userProfiles = result.profiles;
                        this.userProfiles = this.userProfiles.concat(userProfiles);
                        this.endReached = userProfiles.length < this.limit;
                        this.start = this.start + this.limit;
                        this.setState({userProfiles:this.userProfiles});
                        Utils.delay(100).then(()=>{this.loadPageIfEndVisible()});
                        this.busy = false;
                    } else {
                        console.log('cancel ' + apiCallId);
                    }
                })
                .catch((error)=> {
                    console.error('ERROR:');
                    console.error(error);
                })
                .then(()=>{
                    this.setState({busy:this.busy});
                });
        }
    }

    onSelectUser(userProfile) {
        var user2 = this.state.user2;
        var user3 = this.state.user3;
        if(userProfile && (!user2 || user2.id!=userProfile.id) && (!user3 || user3.id!=userProfile.id)) {
            if(!user2) {
                this.setState({user2:userProfile});
            } else if(!user3) {
                this.setState({user3:userProfile});
            }
        }
    }
    onDeselectUser(num) {
        this.setState({['user'+num]:null});
    }

    onChangeSearch(event) {
        this.setState({keywords:event.target.value},this.loadDataDebounced);
    }

    onClickContinue() {
        this.setState({showChallenge:true});
    }

    onCloseChallenge() {
        this.setState({showChallenge:false});
    }

    renderChallenge() {
        var leaderboard = this.props.leaderboard;
        var challengeId = leaderboard.challengeId;
        var seasonId    = leaderboard.seasonId;
        var userProfileIds = [];
        userProfileIds.push(this.props.me.id);
        userProfileIds.push(this.state.user2.id);
        userProfileIds.push(this.state.user3.id);


        var userProfiles = [];
        userProfiles.push(this.props.me);
        userProfiles.push(this.state.user2);
        userProfiles.push(this.state.user3);

        var teamChallengeData = {
            userProfiles:userProfiles,
            leaderboard:leaderboard,
            replacePageOnComplete:true
        };

        return (
            <NavControl key="teamchallenge" onClose={this.onCloseChallenge} closeIconOpts={{key:'teamchallenge', name:'chevron left'}}>
                <Challenge challengeId={challengeId} 
                           teamChallengeData={teamChallengeData}
                           seasonId={seasonId}
                           userProfileIds={userProfileIds} />
            </NavControl>
        );
    }

    renderSelectTeam() {
        return <SelectTeam leaderboard={this.props.leaderboard}
                           me={this.props.me}
                           user2={this.state.user2}
                           user3={this.state.user3}
                           keywords={this.state.keywords}
                           busy={this.state.busy}
                           userProfiles={this.state.userProfiles}
                           onChangeSearch={this.onChangeSearch}
                           onSelectUser={this.onSelectUser} 
                           onDeselectUser={this.onDeselectUser}
                           setScrollContainer={this.setScrollContainer}
                           onScroll={this.onScroll}
                           onClickContinue={this.onClickContinue} />;
    }

    render() {
        if(this.state.showChallenge) {
            return this.renderChallenge();
        } else {
            return this.renderSelectTeam();
        }
    }
}


const mapStateToProps = (state, ownProps) => {
    return {me:state.user.userProfile,
            leaderboard:getLeaderboard(state.leaderboards, ownProps.match.params.id)
            };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadData: (profileParams) => Promise.all([dispatch(fetchLeaderboard(ownProps.match.params.id)), 
                                                  DatabaseService.fetchProfiles(profileParams)]),
        dispatch: dispatch
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('teamchallenges')(SelectTeamContainer)));



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/SelectTeamContainer.js